import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';

@Injectable()
export class OAuthService {
  private mcpSession: string | null = null;
  private mcpCallback: string | null = null;

  constructor(private http: HttpClient) {
    const params = new URLSearchParams(window.location.search);
    this.mcpSession = params.get('mcp_session');
    this.mcpCallback = params.get('mcp_callback');
  }

  get isOAuthFlow(): boolean {
    return !!(this.mcpSession && this.mcpCallback);
  }

  /**
   * Call after a successful login. If an OAuth flow is active, POSTs the
   * Yukka JWT to the MCP server and redirects the browser to the MCP client.
   * Returns an observable that completes without emitting when there is no
   * active OAuth flow.
   */
  handlePostLogin(token: string, email: string): Observable<void> {
    if (!this.isOAuthFlow) {
      return of(undefined);
    }

    return this.http
      .post<{ redirect_url: string }>(this.mcpCallback, {
        session: this.mcpSession,
        token,
        email,
      })
      .pipe(
        tap(({ redirect_url }) => {
          window.location.href = redirect_url;
        }),
        // Callers only care about side effects; swallow the typed value.
        tap({ next: () => {} }),
      ) as Observable<void>;
  }
}
